const errClass = "err";
const checkErrClass = "check-error";
const validateContent = {
    value: document,
};

export const validate = (type, options, validateContentObject = null) => {
    if (validateContentObject) {
        validateContent.value = validateContentObject;
    }
    const func = fieldTypes[type];

    return options.field.hasAttribute("disabled") ? true : func(options);
};

export const clearValidates = (field, validateContentObject) => {
    if (validateContentObject) {
        validateContent.value = validateContentObject;
    }
    return helpers.clear(field);
};

const fieldTypes = {
    string: (options, messages = []) => {
        let field = options.field;
        if (typeof options.rules !== "undefined" && options.rules) {
            const ruleValues = options.rules;
            const ruleKeys = Object.getOwnPropertyNames(ruleValues);
            for (let i = 0; i < ruleKeys.length; i++) {
                const ruleCallback = rules[ruleKeys[i]];
                let validateMessage = {};
                if (
                    typeof options.validateMessages !== "undefined" &&
                    options.validateMessages &&
                    typeof options.validateMessages[ruleKeys[i]] !== "undefined" &&
                    options.validateMessages[ruleKeys[i]]
                ) {
                    validateMessage = options.validateMessages[ruleKeys[i]];
                }
                let attr = "[data-" + field.getAttribute("id") + "-rule]";
                if (ruleCallback(field, ruleValues[ruleKeys[i]], validateMessage, messages) !== true) {
                    helpers.addError(attr, checkErrClass, messages[0]);

                    return false;
                }
                helpers.removeError(attr, checkErrClass, true);
            }
        }

        return true;
    },
    email: (options) => {
        let field = options.field;
        let attr = "[data-" + field.getAttribute("id") + "-rule]";
        if (
            !field.value ||
            !rules.regex(
                field,
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
        ) {
            helpers.addError(
                attr,
                checkErrClass,
                helpers.getLabel(field) + " address should contain @. Example: john.doe@domain.com"
            );

            return false;
        }
        helpers.removeError(attr, checkErrClass, true);

        return fieldTypes.string(options);
    },

    password: (options, messages = []) => {
        let field = options.field;
        let strengthOptions = {
            min: 8,
            lower: 1,
            upper: 1,
            special: 1,
        };
        if (typeof options.strength !== "undefined" && options.strength) {
            strengthOptions = options.strength;
        }
        const keys = Object.getOwnPropertyNames(strengthOptions);
        let lowerPassword = false;
        for (let i = 0; i < keys.length; i++) {
            const key = strengthRules[keys[i]];
            let attr = "[data-" + field.getAttribute("id") + "-rule-" + keys[i] + "]";
            helpers.addError(attr);
            if (!key(field, strengthOptions[keys[i]], messages)) {
                lowerPassword = true;
            } else {
                helpers.removeError(attr);
            }
        }
        let attr = "[data-" + field.getAttribute("id") + "-rule]";
        if (lowerPassword) {
            helpers.addError(
                attr,
                checkErrClass,
                helpers.getLabel(field) + " you entered does not meet the requirements"
            );
            return false;
        }
        helpers.removeError(attr, checkErrClass, true);

        return fieldTypes.string(options);
    },
    phone: (options, messages = []) => {
        let field = options.field;
        let attr = "[data-" + field.getAttribute("id") + "-rule]";
        if (
            rules.regex(field, /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/) &&
            field.value.replace(/\D/g, "").length <= 16
        ) {
            helpers.removeError(attr, checkErrClass, true);

            return fieldTypes.string(options);
        }
        helpers.addError(
            attr,
            checkErrClass,
            "Invalid " + helpers.getLabel(field) + " example: (123) 456-7890, 123-456-7890"
        );

        return false;
    },
};

const rules = {
    max: (field, value, validateMessage = "", messages = []) => {
        if (field.value.length > value) {
            let customMessage = ":label must be shorter then :max !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
                max: value,
            });
            messages.push(customMessage);

            return messages;
        }

        return true;
    },
    min: (field, value, validateMessage = "", messages = []) => {
        if (field.value.length < value) {
            let customMessage = ":label must be shorter then :min !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
                min: value,
            });
            messages.push(customMessage);

            return messages;
        }

        return true;
    },
    betweenLength: (field, value, validateMessage = "", messages = []) => {
        if (rules.max(field, value.max) !== true || rules.min(field, value.min) !== true) {
            let customMessage = ":label must must be between :min and :max characters !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
                min: value.min,
                max: value.max,
            });
            messages.push(customMessage);

            return messages;
        }
        return true;
    },
    confirm: (field, value, validateMessage = "", messages = []) => {
        if (value.value.length <= 0 || field.value !== value.value) {
            let customMessage = ":label s don't match !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
            });
            messages.push(customMessage);

            return messages;
        }

        return true;
    },
    regex: (field, value, validateMessage = "", messages = []) => {
        return value.test(field.value);
    },
    notContainDigits: (field, value, validateMessage = {}, messages = []) => {
        if (rules.regex(field, /\d/g) === true) {
            let customMessage = ":label must not contain digits !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
            });
            messages.push(customMessage);
            return messages;
        }

        return true;
    },
    onlyContainDigits: (field, value, validateMessage = "", messages = []) => {
        if (rules.regex(field, /^\d+$/g) !== true) {
            let customMessage = ":label must contain only digits !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
            });
            messages.push(customMessage);
            return messages;
        }

        return true;
    },
    required: (field, value, validateMessage = "", messages = []) => {
        if (field.value.length === 0) {
            let customMessage = ":label is required !";
            if (validateMessage) {
                customMessage = validateMessage;
            }
            customMessage = helpers.replaceVariables(customMessage, {
                label: helpers.getLabel(field),
            });
            messages.push(customMessage);

            return messages;
        }

        return true;
    },
};

const strengthRules = {
    lower: (field) => {
        return field.value.match(/([a-z])/);
    },
    upper: (field) => {
        return field.value.match(/([A-Z])/);
    },
    special: (field) => {
        return field.value.match(/[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~€¥₤“’•]/);
    },
    number: (field) => {
        return field.value.match(/([0-9])/);
    },
    min: (field, value) => {
        return rules.min(field, value) === true;
    },
};

const helpers = {
    clear: (field) => {
        let attr = "[data-" + field.getAttribute("id") + "-rule]";
        helpers.removeError(attr, checkErrClass, true);
    },
    getLabel: (field) => {
        return field.getAttribute("data-label") ? field.getAttribute("data-label") : field.getAttribute("id");
    },
    addError: (attr, errorClass = errClass, message = null) => {
        helpers.addClass(attr, errorClass);
        if (message) {
            let errorContent = validateContent.value.querySelector(attr);
            if (errorContent) {
                errorContent.innerHTML = message;
            }
        }
    },
    removeError: (attr, errorClass = errClass, hasMassage = false) => {
        helpers.removeClass(attr, errorClass);
        if (hasMassage) {
            let errorContent = validateContent.value.querySelector(attr);
            if (errorContent) {
                errorContent.innerHTML = "";
            }
        }
    },
    addClass: (attr, classText) => {
        validateContent.value.querySelector(attr)?.classList.add(classText);
    },
    removeClass: (attr, classText) => {
        validateContent.value.querySelector(attr)?.classList.remove(classText);
    },
    replaceVariables: (text, params) => {
        return text.replace(/:([a-zA-Z0-9_]+)/g, (match, key) => {
            return params[key] || match;
        });
    },
};
